export const loginOrResZh = {
  login: '登录',
  register: '注册',
  placeholders: {
    phone: '请输入手机号/邮箱',
    psd: '请输入6-16位登录密码',
    rpsd: '请再次输入登录密码',
    imgValicode: '请输入图形验证码',
    validateCode: '手机/邮箱验证码',
    phoneOnly: '请输入手机号',
    emailOnly: '请输入邮箱',
    smsValidateCode: '请输入验证码',
    graphCode: '请输入图形验证码',
    verifCode: '手机/邮箱验证码',
    oldPassword: '请输入旧密码',
    newPassword: '请输入新密码',
    rePassword: '请再次输入新密码',
    verificationCode: '请输入验证码',
    changePsd: '修改密码',
    changePnum: '更换手机',
    changeEmail: '更换邮箱',
    tip1: '请输入新的手机号并进行验证',
    tip2: '请输入新的邮箱并进行验证',
    tip3: '为了账号安全， 请先验证当前手机号：',
    tip4: '请输入新的手机号并进行验证',
    tip5: '为了账号安全， 请先验证当前邮箱：',
    tip6: '该账号不存在，请设置登录密码以完成注册流程',
    tip7: '和',
    oldPwd: '旧密码',
    newPwd: '新密码',
    rNewPwd: '确认密码',
    comfirm: '确认',
    cancel: '取消',
    phone1: '手机',
    email: '邮箱',
    password: '密码',
    Accounts: '账号设置',
    AccountBinding: '账号绑定',
    rightEmail: '请填写正确格式的邮箱',
    rightPhone: '请填写正确格式的手机号',
    ReplacementSuccessful: '更换成功',
    bindNow: '马上绑定'
  },
  forget: '忘记密码?',
  others: '其他登录方式',
  verifTip: '获取验证码',
  smsLogin: '短信登录',
  weChatLogin: '微信登录',
  sendSmsCode: '获取验证码',
  getCode: '获取验证码',
  resendSmsCode: '重新发送',
  acountLogin: '账号密码登录',
  readAndAgreed: '我已阅读并同意',
  profile: '用户协议',
  privateInfo: '隐私政策',
  childernProfile: '儿童用户协议',
  childrenPrivateInfo: '儿童隐私政策',
  errorEmail: '邮箱格式不正确',
  sendAlready: '已发送6位数验证码至手机号',
  toReGet: 's后重新获取',
  checkEmailValidateCode: '邮箱验证码已经成功发送至你的邮箱，请进入邮箱查看。',
  checkSmsValidateCode: '手机验证码已经成功发送至你的手机，请查看。',
  registerSucceed: '注册成功'
}

export const loginOrResEn = {
  login: 'Log In',
  register: 'Sign Up',
  placeholders: {
    phone: 'Please enter your Email Address or Mobile Number',
    psd: 'Please enter your login password（6-16 characters）',
    rpsd: 'Please confirm your login password',
    imgValicode: 'Enter the graphic verification code',
    validateCode: 'Enter the verification code',
    phoneOnly: 'Please Enter the Phone Number',
    emailOnly: 'Please Enter the Email',
    smsValidateCode: 'Please Enter Verification Code.',
    graphCode: 'Enter the graphic verification code',
    verifCode: 'Enter the verification code',
    oldPassword: 'Please enter your old password',
    newPassword: 'Please enter a new password',
    rePassword: 'Please enter the new password again',
    verificationCode: 'Please enter the verification code',
    changePsd: 'Change password',
    changePnum: 'Replace the phone',
    changeEmail: 'Change email',
    tip1: 'Please enter a new phone number and verify it',
    tip2: 'Please enter a new email and verify it',
    tip3: 'For account security, please verify your current phone number first：',
    tip4: 'Please enter a new phone number and verify it',
    tip5: 'For account security, please verify your current email first：',
    tip6: 'Successfully replaced. The account does not exist. Please set the login password to complete the registration process',
    tip7: 'and',
    oldPwd: 'Old password',
    newPwd: 'New Password',
    rNewPwd: 'Confirm password',
    comfirm: 'Confirm',
    cancel: 'Cancel',
    phone1: 'phone',
    email: 'Email',
    password: 'Password',
    Accounts: 'Accounts Setting',
    AccountBinding: 'Accounts Bindding',
    rightEmail: 'Please fill in the correct email format',
    rightPhone: 'Please fill in the correct format of your phone number',
    ReplacementSuccessful: 'Replacement Successful',
    bindNow: 'Bind now'
  },
  forget: 'Forgot Your Password？',
  others: 'Other Login Methods',
  verifTip: 'Send code',
  smsLogin: 'Message Login',
  weChatLogin: 'WeChat Login',
  sendSmsCode: 'Send code',
  getCode: 'Obtain verification code',
  resendSmsCode: 'Resend',
  acountLogin: 'Account Password Login',
  readAndAgreed: 'I have carefully read and agree to the above  agreements',
  profile: 'User Agreement',
  privateInfo: 'Privacy Policy',
  childernProfile: 'Children User Agreement',
  childrenPrivateInfo: 'Children Privacy Policy',
  errorEmail: 'Invalid Email Format',
  sendAlready: 'A 6-digit verification code has been sent to the phone number.',
  toReGet: 'Resend',
  checkEmailValidateCode: 'Email verification code has been successfully sent to your email, please enter the email to check.',
  checkSmsValidateCode: 'Message verification code has been successfully sent to your phone, please check it.',
  registerSucceed: 'Email verification code has been successfully sent to your email, please enter the email to check.'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/loginOrRes/index.js